import getNodeOffset from './getNodeOffset'
let symbolList = []
window.curFocus = null

export let symbol = {
  inserted: function(el) {
    let focusList = ['INPUT', 'TEXTAREA']
    let ele = el
    if(!focusList.includes(ele.tagName)) {
      for(let i = 0; i < el.childNodes.length; i++ ) {
        let tagName = el.childNodes[i].tagName
        if(focusList.includes(tagName)) {
          ele = el.childNodes[i]
          break;
        }
      }
    }

    symbolList.push(ele)

    ele.onfocus = function() {
      let {top, left} = getNodeOffset(ele),
      symbolDom = document.querySelector('.mathematical-symbols')
      window.curFocus = ele
      symbolDom.style = `
        left: ${left}px;
        display: flex;
      `
      symbolDom.style.top = `${Number(top) - symbolDom.offsetHeight}px`;
    }

    ele.onblur = function() {
      let symbolDom = document.querySelector('.mathematical-symbols')
      symbolDom.style.display = 'none'
    }

  }
}